<template>
  <div :class="getScreen ? 'm-page-wrapper' : 'd-page-wrapper'">
    <div v-if="id === null || id === undefined">
      <a-card class="m-wrong">
        <m-anim
          :options="notfound"
          class="anim"
          :height="getScreen ? 200 : 500"
          :width="getScreen ? 200 : 500"
        ></m-anim>
        <h3>Not Found</h3>
        <p>
          Return to the previous page and make the selection manifest again!
        </p>
        <a-button type="primary" block @click="$router.go(-1)">
            <a-icon type="rollback" />&nbsp; Return
        </a-button>
      </a-card>
    </div>
    <div v-else>
      <a-row :gutter="8">
        <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
          <a-card :loading="loading.manifest">
            <div slot="title">
              Traveloka Claim Manifest
              <small class="m-display-block m-text-small">{{
                manifest.header.no_transaksi
              }}</small>
            </div>
            <a-popover slot="extra" trigger="click" placement="bottom">
              <span slot="title">Select Action</span>
              <ul class="m-list-wrapper bordered" slot="content">
                <li v-if="getAuth.username == manifest.header.tlc">
                  <a-button-group class="width-full">
                    <a-button
                      :disabled="
                        !(
                          manifest.lastStatus == 'Revised' &&
                          getAuth.username == manifest.header.tlc
                        )
                      "
                      type="dashed"
                      class="width-full"
                      icon="edit"
                      @click="handleEdit"
                      >Edit</a-button
                    >
                    <!-- <a-button
                      @click="handlecanceltrans"
                      :disabled="manifest.header.dana_sts=='1'"
                      type="danger"
                      icon="close-square"
                      :loading="loading.cancel"
                      >Cancel</a-button
                    > -->
                  </a-button-group>
                </li>
                <li>
                  <a-button
                    @click="handlePrintReport('claim')"
                    type="dashed"
                    icon="printer"
                    block
                    class="m-display-block"
                    :loading="loading.report"
                    :diabled="loading.manifest"
                    >Claim Traveloka Report</a-button
                  >
                </li>
                <li v-if="manifest.header.iskomisi &&
                  getAuth.username != manifest.header.tlc">
                  <a-button
                    type="primary"
                    size="small"
                    icon="printer"
                    block
                    ghost
                    @click="handlePrintReport('komisi')"
                    class="m-display-block"
                    :loading="loading.manifestKomisi"
                    >Commision Report</a-button
                  >
                </li>
                <li v-if="manifest.header.iskomisi &&
                  getAuth.username != manifest.header.tlc
                ">
                  <a-button
                    type="primary"
                    size="small"
                    icon="printer"
                    block
                    ghost
                    :loading="loading.manifestfiktif"
                    @click="handlePrintReport('fiktif')"
                    class="m-display-block"
                    >Fictitious Name Report</a-button
                  >
                </li>
                <li v-if="manifest.header.iskomisi">
                  <a-button
                    type="primary"
                    size="small"
                    icon="printer"
                    block
                    ghost
                    :loading="loading.manifestWtNote"
                    @click="handlePrintReport('tanpa_nota')"
                    class="m-display-block"
                    >Approval Commision Report</a-button
                  >
                </li>
              </ul>
              <a-button icon="more">Action</a-button>
            </a-popover>

            <div class="m-card-body">
              <ul class="m-list-wrapper bordered">
                <li>
                  <span class="m-list-title" for>Created Date</span>
                  <span class="m-list-desc">{{ manifest.header.report_date }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>User Creator</span>
                  <span class="m-list-desc">{{
                    manifest.header.tlc
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>User CC</span>
                  <span class="m-list-desc">{{
                    manifest.header.user_cc
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Total</span>
                  <span class="m-list-desc">{{
                    formatCurrency(manifest.header.currency, manifest.header.total)
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Note</span>
                  <span class="m-list-desc">{{ manifest.header.note }}</span>
                </li>
              </ul>
            </div>
          </a-card>

          <a-collapse class="margin-top" activeKey="1">
            <a-collapse-panel key="1"  >
              <h4 slot="header" class="margin-remove">Usage Details</h4>
              <div v-if="getScreen">
                <a-list
                  itemLayout="vertical"
                  :dataSource="searching"
                  :pagination="pagination"
                  :loading="loading.manifest"
                >
                  <a-list-item slot="renderItem" slot-scope="item">
                    <a-list-item-meta>
                      <span slot="title">
                        {{ item.type_ticket }} / {{ item.user_booking }} / {{ item.no_booking }}
                      </span>
                      <div slot="description" class="margin-remove">
                        <span>{{ moment(item.expense_date).format(getDefaultDateFormat) }}</span>
                        <div>
                          <span>{{ item.no_sppd || item.no_pp || item.cost_center }}</span>
                          <div>is Commision : {{ item.iscommision=='1' ? 'Yes' : 'No' }}</div>
                          <h4 class="margin-remove">
                            {{ formatCurrency(manifest.header.currency, item.credit) }}
                          </h4>
                        </div>
                        <a-button-group v-if="manifest.header.tlc == getAuth.username" class="margin-top">
                          <a-button type="primary" icon="edit" @click="handleUploadDoc(item)"></a-button>
                          <a-button type="default" icon="eye" @click="viewlampiranDoc(item.lampiran_path)" v-if="item.lampiran">View</a-button>
                          <a-button type="default" disabled v-else>No File</a-button>
                        </a-button-group>
                        <a v-else-if="item.lampiran" @click="viewlampiranDoc(item.lampiran_path)" class="margin-top">
                          View Document
                        </a>
                        <div v-else class="margin-top">
                          :: No File Uploaded ::
                        </div>

                        <div v-if="isTaxOfficer">
                          <a-button icon="edit" class="margin-top"
                            :type="item.tax_verif !== '0' ? 'primary' : 'danger'"
                            style="margin-right:5px" @click="handleShowTaxModal(item)"
                            :disabled="!(manifest.jenis !== 'Verifikator' || item.id_dtl == null && item.id_hdr == null)"
                            >
                            Tax
                          </a-button>
                        </div>

                      </div>
                    </a-list-item-meta>
                  </a-list-item>
                </a-list>
              </div>
              <div v-else>
                <a-input-search
                v-model="search"
                placeholder="Quick Search"
                allowClear
                class="margin-bottom"
              />
              <a-table
                :columns="columns"
                :dataSource="searching"
                :pagination="pagination"
                :loading="loading.manifest"
                :rowKey="(record, index) => { return index; }" 
                size="small"
                bordered
                :scroll="{ x: 950 }"
              >
                <span slot="no" slot-scope="text, item, index">
                  {{ (pagination.page - 1) * pagination.pageSize + index + 1 }}
                </span>
                <span slot="tgl" slot-scope="item">
                  {{ moment(item.expense_date).format(getDefaultDateFormat) }}
                </span>
                <span slot="type" slot-scope="item">
                  {{ item.type_ticket }} / {{ item.user_booking }} / {{ item.no_booking }}
                </span>
                <span slot="val" slot-scope="item">
                  <CurrencyJustified
                    v-if="item.credit"
                    :currencyValue="manifest.header.currency"
                    :valueNumber="item.credit"
                  />
                  <div v-else style="text-align: center; width: 100%">-</div>
                </span>
                <span slot="budget" slot-scope="item">
                  <div v-if="item.no_sppd">SPPD : {{ item.no_sppd }}</div>
                  <div v-if="item.no_pp">PP : {{ item.no_pp }}</div>
                  <div v-if="!item.no_sppd && !item.no_pp && item.kode_anggaran">ANGGARAN : {{ item.kode_anggaran }}</div>
                  <div v-if="item.no_sppd || item.no_pp"><small><i>Anggaran : {{ item.kode_anggaran }}</i></small></div>
                  <div v-if="item.no_prospek"><small><i>Prospek : {{ item.no_prospek }} - {{ item.description_prospek }}</i></small></div>
                </span>
                <div slot="iscommision" slot-scope="item">
                  {{ item.iscommision=='1' ? 'Yes' : 'No' }}
                </div>
                <template slot="document" slot-scope="item">
                  <a-button-group v-if="manifest.header.tlc == getAuth.username" class="margin-top">
                    <a-button type="primary" icon="edit" @click="handleUploadDoc(item)"></a-button>
                    <a-button type="default" icon="eye" @click="viewlampiranDoc(item.lampiran_path)" v-if="item.lampiran">View</a-button>
                    <a-button type="default" disabled v-else>No File</a-button>
                  </a-button-group>
                  <a v-else-if="item.lampiran" @click="viewlampiranDoc(item.lampiran_path)">
                    View Document
                  </a>
                  <span v-else>
                    No File Uploaded
                  </span>
                </template>

                <span slot="doc_tax" slot-scope="item">
                  <div style="text-align: center;">
                    <a-button icon="edit" size="small"
                      :type="item.tax_verif !== '0' ? 'primary' : 'danger'"
                      style="margin-right:5px" @click="handleShowTaxModal(item)"
                      :disabled="!(manifest.jenis !== 'Verifikator' || item.id_dtl == null && item.id_hdr == null)"
                      >
                    </a-button>
                  </div>
                </span>

                <div slot="footer" class="padding-all">
                  <a-row type="flex">
                    <a-col :span="12" :order="1" class="m-text-align left"
                      >Total Credit Ticket + Jasa + PPN - PPh </a-col
                    >
                    <a-col
                      :span="4"
                      :order="2"
                      class="m-text-align left m-text-bold"
                    ></a-col>
                    <a-col
                      :span="8"
                      :order="3"
                      class="m-text-align left m-text-bold"
                    >
                      <CurrencyJustified
                        :currencyValue="manifest.header.currency"
                        :valueNumber="manifest.total_credit"
                      />
                    </a-col>
                  </a-row>
                  <a-row type="flex">
                    <a-col :span="12" :order="1" class="m-text-align left"
                      >Total Refund </a-col
                    >
                    <a-col
                      :span="4"
                      :order="2"
                      class="m-text-align left m-text-bold"
                    ></a-col>
                    <a-col
                      :span="8"
                      :order="3"
                      class="m-text-align left m-text-bold"
                    >
                      <CurrencyJustified
                        :currencyValue="manifest.header.currency"
                        :valueNumber="manifest.total_refund"
                      />
                    </a-col>
                  </a-row>
                  <a-row type="flex">
                    <a-col :span="12" :order="1" class="m-text-align left"
                      ><b>Grand Total (Total Credit - Total Refund)</b></a-col
                    >
                    <a-col
                      :span="4"
                      :order="2"
                      class="m-text-align left m-text-bold"
                    ></a-col>
                    <a-col
                      :span="8"
                      :order="3"
                      class="m-text-align left m-text-bold"
                    >
                      <CurrencyJustified
                        :currencyValue="manifest.header.currency"
                        :valueNumber="manifest.grand_total"
                      />
                    </a-col>
                  </a-row>
                </div>
              </a-table>
              </div>
            </a-collapse-panel>
          </a-collapse>

          <a-card v-if="['Approve','Verifikator'].includes(manifest.jenis)" class="margin-top">
            <div slot="title">Manifest Actions</div>
            <a-form :form="form" id>
              <a-row>
                <a-col>
                  <a-form-item label="Note">
                    <a-textarea
                      placeholder="Write the note here ... "
                      :rows="4"
                      v-decorator="[
                        'catatan',
                        {
                          rules: [{ required: false }],
                          initialValue: null,
                        },
                      ]"
                    />
                  </a-form-item>

                  <a-form-item label="Status" v-if="manifest.aksi.length != 0">
                    <a-select
                      showSearch
                      v-decorator="[
                        'status',
                        {
                          rules: [{ required: true }],
                          initialValue: null,
                        },
                      ]"
                    >
                      <a-select-option
                        v-for="da in manifest.aksi"
                        :key="da.aksi"
                        >{{ da.aksi }}</a-select-option
                      >
                    </a-select>
                  </a-form-item>
                </a-col>
              </a-row>
            </a-form>
            <template class="ant-card-actions" slot="actions">
              <div class="steps-action">
                <a-button
                  type="primary"
                  html-type="submit"
                  :loading="loading.submit"
                  block
                  @click="submitConfirm"
                  >Save</a-button
                >
              </div>
            </template>
          </a-card>
        </a-col>
        <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
          <a-collapse activeKey="1" :class="getScreen ? 'margin-top' : ''">
            <a-collapse-panel key="1">
              <div
                class="m-display-flex space-between align-middle"
                slot="header"
              >
                <h4 class="margin-remove">Transaction status</h4>
                <div>
                  <Status :status="manifest.lastStatus" />
                  <a-button
                    @click="historyToggle"
                    type="default"
                    size="small"
                    class="margin-right-small"
                  >
                    <a-icon type="history" />
                  </a-button>
                </div>
              </div>
              <a-spin :spinning="loading.manifest">
                <a-timeline class="m-timeline">
                  <a-timeline-item color="green">
                    <div class="m-timeline-title">
                      Pembuat - {{ manifest.header.tlc }}
                    </div>
                    <div class="m-timeline-body">
                      <h4 class="margin-remove">
                        {{
                          moment(manifest.header.report_date).format(getDateTimeFormat)
                        }}
                      </h4>
                      <span class="m-text-small" v-if="manifest.header.note">{{
                        manifest.header.note
                      }}</span>
                      <span class="m-text-small" v-else>Tidak Ada Catatan</span>
                    </div>
                    <div class="m-timeline-footer">
                      <a-tag color="green">Created</a-tag>
                    </div>
                  </a-timeline-item>
                  <a-timeline-item
                    color="green"
                    v-for="(workflow, i) in manifest.workflowStatus"
                    :key="workflow.step_no"
                  >
                    <div class="m-timeline-title">
                      {{ workflow.actor }} - {{ workflow.tlc }}
                    </div>
                    <div class="m-timeline-body">
                      <h4
                        class="margin-remove"
                        v-if="workflow.tanggal_aksi !== null"
                      >
                        {{
                          moment(workflow.tanggal_aksi).format(getDateTimeFormat)
                        }}
                      </h4>
                      <span class="m-text-small" v-if="workflow.remark">{{
                        workflow.remark
                      }}</span>
                      <span class="m-text-small" v-else>Tidak Ada Catatan</span>
                    </div>
                    <div class="m-timeline-footer">
                      <Status :status="workflow.status" />
                    </div>
                  </a-timeline-item>
                </a-timeline>
              </a-spin>
            </a-collapse-panel>
          </a-collapse>
        </a-col>
      </a-row>
    </div>

    <a-modal v-model="visibleHistory" @ok="historyToggle" :footer="null">
      <span slot="title"> <a-icon type="history" />&nbsp;History Status </span>

      <ul class="m-list-wrapper bordered">
        <li v-for="history in manifest.history" :key="history.id_notifikasi">
          <div v-if="history.aksi === '1' || history.aksi === '3'">
            <div class="m-display-flex space-between">
              <h3 class="margin-remove m-list-title">
                {{ history.as_from }} | {{ history.tlc_from }}
              </h3>
              <Status :status="history.deskripsi" />
            </div>
            <span class="m-list-desc">{{ history.tgl_notif }}</span>
          </div>
          <div v-else-if="history.aksi === '2' || history.aksi === '4'">
            <div class="m-display-flex space-between">
              <h3
                class="margin-remove m-list-title"
                v-if="history.aksi === '4' && history.deskripsi === 'Edited'"
              >
                {{ history.as_from }} | {{ history.tlc_from }}
              </h3>
              <h3 class="margin-remove m-list-title" v-else>
                {{ history.as_to }} | {{ history.tlc_to }}
              </h3>
              <Status :status="history.deskripsi" />
            </div>
            <span class="m-list-desc">{{ history.tgl_notif }}</span>
          </div>
        </li>
      </ul>
    </a-modal>

    <a-modal v-model="visibleUploadDoc" @ok="historyToggle" :footer="null">
      <span slot="title"> <a-icon type="upload" />&nbsp;Upload Transaction Document </span>
      <a-spin tip="Your document is being processed, do not leave this page!" :spinning="uploadDoc.loading"
      >
        <a-row :gutter="8">
          <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
            <b>Tanggal</b>
          </a-col><a-col :xs="{ span: 24 }" :lg="{ span: 1 }">:</a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 15 }">
            <a-input v-model="uploadDoc.tanggal" disabled></a-input>
          </a-col>
        </a-row>
        <a-row :gutter="8" class="margin-top">
          <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
              <b>Description</b>
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 1 }">:</a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 15 }">
              <a-textarea v-model="uploadDoc.deskripsi" disabled></a-textarea>
            </a-col>
        </a-row>
        <a-row :gutter="8" class="margin-top">
          <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
              <b>Transaction Document</b>
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 1 }">:</a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 15 }">
              <a-upload
                :showUploadList="true"
                :fileList="uploadDoc.doctransfiles"
                :beforeUpload="beforedoctransUpload"
                v-model="uploadDoc.file"
                :disabled="uploadDoc.loading"
              >
              <!-- :remove="handledoctransRemove" -->
                <a-button>
                  <a-icon type="upload" />&nbsp;Select File
                </a-button>
              </a-upload>
            </a-col>
        </a-row>
      </a-spin> 
    </a-modal>

    <a-modal :visible="visibleTaxDeposite" @cancel="handleModalClose" :maskClosable="false" :width="'90%'">
      <span slot="title"> <a-icon type="reconciliation" />&nbsp;Verification Transaction Tax </span>
      <a-row :gutter="16">
        <!-- <a-col :xs="{ span: 24 }" :lg="{ span: expand.leftcolumn }"> -->
          <a-col :xs="{ span: 24 }">
          <a-spin :spinning="spinning_form" tip="Loading ...  ">
            <div class="container-dash">

              <a-form :form="formmodal">
                <div class="container-essential">
                  <a-row :gutter="12">
                    <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                      <a-form-item label="Detil transaction">
                        <a-select showSearch v-decorator="['id_dtl',
                          {
                            rules: [{ required: true }], initialValue: modalData.init_detil_transaction ? modalData.init_detil_transaction.id_dtl : null
                          },
                        ]" :disabled="true" class="select-between s_trans" @change="handle_DetilTransaction" ref="refid_dtl"
                          optionFilterProp="children" :filterOption="filterOptiondtl">
                          <a-select-option v-for="item in modalData.detil_transaction" :key="item.id_dtl"
                            :disabled="item.disabled">
                            <div style="display: flex;justify-content: space-between;opacity: 1;width: 100%;">
                              <div>[{{ moment(item.tgl, getStandartFormatDate).format(getDefaultDateFormat) }}] {{ item.deskripsi + ' ' }}</div>
                              <div style="float: right;"><b>{{ formatCurrency(item.currency, parseFloat(item.kredit)) }}</b></div>
                            </div>
                          </a-select-option>
                        </a-select>
                        <div v-if="modalData.init_detil_transaction && modalData.init_detil_transaction.potensial_tax" class="m-form-description-small">
                          <div style="width:100%;">
                            <span>
                              {{ modalData.init_detil_transaction ? modalData.init_detil_transaction.credit : null }}
                            </span><br />
                            <div v-if="modalData.init_detil_transaction && modalData.init_detil_transaction.potensial_tax == '1'" class="lbltaxable">
                              {{ 'POTENTIALLY TAXABLE' }}</div>
                            <div v-else class="lblnottaxable">
                              {{ "IS'NT POTENTIALLY TAXABLE" }}
                            </div>
                          </div>
                        </div>

                      </a-form-item>
                    </a-col>
                    <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                      <a-form-item label="Verificator Note">
                        <a-textarea disabled :rows="4" v-model="modalData.init_detil_transaction.verificator_note" />
                      </a-form-item>
                    </a-col>
                  </a-row>
                </div>

                <div class="container-dash" style="margin-top:12px;margin-bottom:12px">
                  <a-row :gutter="8">
                    <a-col :xs="{ span: 24 }" :lg="{ span: 6 }">
                      <a-form-item label="Value After Tax">
                        <a-radio-group button-style="solid" v-decorator="['is_vat', { rules: [{ required: true }], initialValue: '1' }]"
                          @change="handleChangeVat" ref="ref_is_vat" :disabled="modalData.anggaran.loadingtree">
                          <a-radio-button value="1">Yes</a-radio-button>
                          <a-radio-button value="0">No</a-radio-button>
                        </a-radio-group>
                      </a-form-item>
                    </a-col>
                    <a-col :xs="{ span: 24 }" :lg="{ span: 6 }">
                      <a-form-item label="Cost Center">
                        <a-select
                          :disabled="modalData.costcenter.length == 0 || isvat || modalData.anggaran.loadingtree"
                          showSearch v-decorator="[
                            'cost_center',
                            {
                              rules: [{ required: !isvat }],
                              initialValue: modalData.init_detil_transaction ? modalData.init_detil_transaction.anggaran_id : null,
                            },
                          ]" placeholder="Please Select Cost Center" @change="handleCost">
                          <a-select-option v-for="item in modalData.costcenter" :key="item.value">{{ item.text }}
                            ({{
                              item.nama_pekerjaan ? item.nama_pekerjaan : "-"
                            }})</a-select-option>
                        </a-select>
                      </a-form-item>
                    </a-col>
                    <a-col :xs="{ span: 24 }" :lg="{ span: 6 }">
                      <a-form-item label="Allotment">
                        <a-select
                          :disabled="modalData.peruntukan.length == 0 || isvat || modalData.anggaran.loadingtree"
                          showSearch v-decorator="[
                            'peruntukan',
                            {
                              rules: [{ required: !isvat }],
                              initialValue: modalData.init_detil_transaction ? modalData.init_detil_transaction.peruntukan_id : null,
                            },
                          ]" placeholder="Please Select Allotment" @change="handle_Peruntukan" ref="refperuntukan"
                          optionFilterProp="children" :filterOption="filterOption">
                          <a-select-option v-for="item in modalData.peruntukan" :key="item.value">
                            {{ item.text }}
                          </a-select-option>
                        </a-select>
                      </a-form-item>
                    </a-col>
                    <a-col :xs="{ span: 24 }" :lg="{ span: 6 }">
                      <a-form-item label="Budget Code">
                        <a-tree-select v-decorator="[
                          'kode_anggaran',
                          {
                            rules: [{ required: !isvat }],
                            initialValue: modalData.init_detil_transaction ? modalData.init_detil_transaction.kode_anggaran : null,
                          },
                        ]" show-search style="width: 100%" @select="handlechoiceCost"
                          :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                          :tree-data="modalData.anggaran.tree" treeNodeFilterProp="children"
                          :filterTreeNode="filterTreeNode" placeholder="Please Select Budget Code"
                          :treeExpandedKeys="modalData.treeExpandedKeys" allow-clear :disabled="modalData.anggaran.loadingtree ||
                            modalData.anggaran.tree == undefined ||
                            modalData.anggaran.tree.length == 0 || isvat
                            " tree-default-expand-all>
                          <span slot="title" slot-scope="item">
                            <table style="width:100%">
                              <tr>
                                <td>
                                  <span>{{ item.texttitle }} -
                                    {{ item.kode_anggaran }}</span>
                                </td>
                                <td>
                                  <span style="float:right"><b>{{
                                    formatRupiah(parseFloat(item.rekap))
                                  }}</b></span>
                                </td>
                              </tr>
                            </table>
                          </span>
                          <template slot="suffixIcon"><a-icon :type="modalData.anggaran.loadingtree ? 'loading' : 'down'" />
                          </template>
                        </a-tree-select>
                      </a-form-item>
                    </a-col>
                  </a-row>
                </div>

                <a-row :gutter="8">
                  <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                    <div class="container-dash">
                      <a-row :gutter="8">
                        <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                          <a-form-item label="Tax Type">
                            <a-select v-decorator="[
                              'tax_type',
                              {
                                rules: [{ required: true }],
                                initialValue: modalData.type_pajak,
                              },
                            ]" show-search optionFilterProp="children" :filterOption="filterOption"
                              @change="handleChangeTaxType">
                              <a-select-option v-for="item in getType_taxFiltered" :key="item.value" :value="item.value">
                                {{ item.text }}
                              </a-select-option>
                            </a-select>
                          </a-form-item>
                          <a-form-item label="Tax Deposit">
                            <a-select v-decorator="[
                              'kode_setoran_pajak',
                              {
                                rules: [{ required: true }],
                                initialValue: modalData.tax_deposit,
                              },
                            ]" option-filter-prop="children" :filter-option="filterOption" showSearch>
                              <a-select-option v-for="item in modalData.listsetoranpajak" :key="item.value"
                                :value="item.value" :text="item.text">
                                {{ item.text }}
                              </a-select-option>
                            </a-select>
                          </a-form-item>
                          <a-form-item label="Tax Object" v-if="!(
                            modalData.reftax_type == 'pph_21' ||
                            modalData.reftax_type == 'ppn'
                          )
                            ">
                            <a-select v-decorator="[
                              'objek_pajak',
                              {
                                rules: [{ required: false }],
                                initialValue: modalData.tax_object,
                              },
                            ]" option-filter-prop="children" :filter-option="filterOption" showSearch allowClear>
                              <a-select-option v-for="item in modalData.listobjekpajak" :key="item.value"
                                :value="item.value" :text="item.text">
                                {{ item.text }}
                              </a-select-option>
                            </a-select>
                          </a-form-item>
                        </a-col>
                        <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                          <a-form-item label="DPP Value">
                            <a-input-number class="m-width-full m-text-align-right"
                              v-on:keydown.enter.prevent="preventEnterButton"
                              :formatter="(value) => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                              :parser="(value) => value.replace(/\\s?|(,*)/g, '')" v-decorator="['dpp_value',
                                {
                                  rules: [{ required: true, validator: checkPrice }],
                                  initialValue: modalData.dpp_value,
                                },
                              ]" />
                          </a-form-item>
                          <a-form-item label="Tax Value">
                            <a-input-number class="m-width-full m-text-align-right"
                              v-on:keydown.enter.prevent="preventEnterButton"
                              :formatter="(value) => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                              :parser="(value) => value.replace(/\\s?|(,*)/g, '')" v-decorator="[
                                'tax_value',
                                {
                                  rules: [{ required: true, validator: checkPrice }],
                                  initialValue: modalData.tax_value,
                                },
                              ]" />
                          </a-form-item>
                          <a-form-item label="File Document Tax">
                            <a-upload :fileList="modalData.fileList" v-decorator="[
                              'file_document_tax',
                              {
                                rules: [
                                  { required: false, validator: doc_validation },
                                ],
                              },
                            ]" :remove="handleRemoveAttachment" :beforeUpload="beforeUploadAttachment">
                              <a-button> <a-icon type="upload" />Select File </a-button>
                            </a-upload>
                          </a-form-item>
                        </a-col>
                      </a-row>
                      <a-button v-if="modalData.state_modal == 'add'" type="primary" icon="disk"
                        @click="handleAddVarification" ref="addMainBtn" :loading="addVarification"
                        :disabled="modalData.anggaran.loadingtree" class="m-width-full margin-top">
                        Add
                      </a-button>
                      <a-row :gutter="8" v-else>
                        <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                          <a-button type="primary" @click="handleUpdateDetail" ref="addMainBtn"
                            :loading="addVarification" class="m-width-full margin-top"
                            :disabled="modalData.anggaran.loadingtree">
                            Change
                          </a-button>
                        </a-col>
                        <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                          <a-button type="danger" @click="handleCancelVarification" ref="addMainBtn"
                            class="m-width-full margin-top" :disabled="modalData.anggaran.loadingtree">
                            Cancel
                          </a-button>
                        </a-col>
                      </a-row>
                    </div>
                  </a-col>

                  <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                    <a-config-provider :locale="getLocalConfigProvider()">
                      <a-table bordered size="small" id="tbl_data_dtl" :rowKey="(record, index) => { return index; }"
                        :columns="table.verificationdtl" :dataSource="data_verif_dtl"
                        :pagination="paginationverificationdtl" :scroll="{ x: 835 }"
                        :rowClassName="(record, index) => { return record.id == modalData.id_tax_verif_trans ? 'selectedRow' : '' }">
                        <template slot="title">
                          List Details
                        </template>
                        <template slot="nomor" slot-scope="text, data,index">
                          <div class="m-text-align right">{{ index + 1 }}</div>
                        </template>
                        <template slot="detail" slot-scope="data">
                          {{ data.detail }}
                        </template>
                        <template slot="no_trans" slot-scope="data">
                          {{ data.no_trans }}
                        </template>
                        <template slot="type_tax" slot-scope="data">
                          <div class="m-text-align left">{{ gettitletax(dataTax.tax_type) }}</div>
                        </template>
                        <template slot="dpp_value" slot-scope="data">
                          <CurrencyJustified :currencyValue="'IDR'" :valueNumber="data.dpp_value" />
                        </template>
                        <template slot="tax_value" slot-scope="data">
                          <CurrencyJustified :currencyValue="'IDR'" :valueNumber="data.tax_value" />
                        </template>
                        <template slot="action" slot-scope="text,data,index">
                          <a-button-group>
                            <a-button type="primary" @click="editdtl(data)" icon="edit" size="small"
                              :disabled="modalData.state_modal == 'edit'">
                            </a-button>
                            <a-button type="danger" @click="deletedtl(data.id)" icon="close" size="small"
                              :disabled="modalData.state_modal == 'edit'" :loading="deleteVarification && data.id == modalProcessKey">
                            </a-button>
                          </a-button-group>
                        </template>
                      </a-table>
                    </a-config-provider>
                  </a-col>

                </a-row>
              </a-form>

            </div>
          </a-spin>
        </a-col>

        <!-- <a-col :xs="{ span: 24 }" :lg="{ span: expand.rightcolumn }">
          <div class="container-headertable">
            <div class="m-display-flex space-between align-middle">
              <span>List Details</span>
            </div>
          </div>
          <a-config-provider :locale="getLocalConfigProvider()">
            <a-table bordered size="small" id="tbl_dtl" :rowKey="(record, index) => { return index; }"
              :columns="columns.verificationdtl" :dataSource="verificationdtl_source"
              :pagination="paginationverificationdtl" :scroll="{ x: 835 }">
              <template slot="title">
                <a-input-search v-decorator="['searchListDtl', { rules: [{ required: false }] }]"
                  @change="searchingListDtl" placeholder="Quick Search" />
              </template>
              <template slot="nomor" slot-scope="text, data,index">
                <div class="m-text-align right">{{ index + 1 }}</div>
              </template>
              <template slot="detail" slot-scope="data">
                <div class="m-text-align left">{{ data.detail }}</div>
                <small v-if="data.kode_anggaran"><i>[{{ data.kode_anggaran + "-" + data.item_anggaran }}]</i></small>
              </template>
              <template slot="notrans" slot-scope="data">
                <div class="m-text-align center">{{ data.no_trans }}</div>
              </template>
              <template slot="dttrans" slot-scope="data">
                <div class="m-text-align center">{{ moment(data.tgl, getStandartFormatDate).format(getDefaultDateFormat)
                }}</div>
              </template>
              <template slot="price" slot-scope="data">
                <div class="m-text-align center">{{ formatCurrency('IDR', data.harga) }}</div>
              </template>
              <template slot="pttax" slot-scope="data">
                <div class="m-text-align center">{{ data.potensial_tax && data.potensial_tax == "1" ? "Yes" : "No" }}
                </div>
              </template>
              <template slot="type" slot-scope="data">
                <div class="m-text-align left">{{ gettitletax(data.tax_type) }}</div>
              </template>
              <template slot="dppvalue" slot-scope="data">
                <CurrencyJustified :currencyValue="'IDR'" :valueNumber="data.dpp_value" />
              </template>
              <template slot="value" slot-scope="data">
                <CurrencyJustified :currencyValue="'IDR'" :valueNumber="data.tax_value" />
              </template>
              <template slot="action" slot-scope="text,data,index">
                <div :class="loading.loadJenis == 'view' ? 'm-text-align center' : 'm-text-align right'">
                  <a-button-group>
                    <a-tooltip class="m-tooltip-inner" placement="bottomRight" title="View File">
                      <a-button
                        :disabled="data.tax_document_name == '' || data.tax_document_name == null || loading.spinform"
                        type="default" @click="viewFiledtl(data.tax_document_name, data.tax_document_path)" icon="file"
                        size="small">
                      </a-button>
                    </a-tooltip>
                    <a-tooltip class="m-tooltip-inner" placement="bottomRight" title="Edit Row">
                      <a-button v-if="loading.loadJenis != 'view'" type="primary" @click="editdtl(data.id)" icon="edit"
                        size="small" :loading="loading.spinform && data.id == modalData.id_tax_verif_trans"
                        :disabled="loading.spinform || modalData.id_tax_verif_trans != ''">
                      </a-button>
                    </a-tooltip>
                  </a-button-group>
                </div>
              </template>
            </a-table>
          </a-config-provider>
        </a-col> -->
      </a-row>
      <!-- v-if="loading.loadJenis != 'view'" -->
      <div slot="footer">
        <a-button @click="handleModalClose" type="danger"
          :disabled="modalData.anggaran.loadingtree">
          Return to Manifest</a-button>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import notfound from "@/assets/anim/notfound.json";
import axios from "axios";
import _ from "lodash";
import moment, { locale } from "moment";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import GlobalMethod from "@/mixins/GlobalMethod.js";

export default {
  name: "travelokaklaimManifest",
  props: ["id"],
  components: {},
  mixins: [CurrencyFormat, GlobalMethod],
  data() {
    let doc_validation = (rule, value, callback) => {
      if (this.modalData.fileList && this.modalData.fileList == null) {
        callback(new Error("Please Complete Your Form Input!"));
      } else {
        callback();
      }
    };
    const table = {
      verificationdtl: [
        {
          title: "#",
          key: "nomor",
          scopedSlots: { customRender: "nomor" },
          width: 50,
        },
        // {
        //   title: "Transaction Date",
        //   key: "tgl",
        //   scopedSlots: { customRender: "tgl_trans" },
        //   width: 150,
        // },
        // {
        //   title: "Detil transaction",
        //   key: "detail",
        //   scopedSlots: { customRender: "detail" },
        //   width: 230,
        // },
        // {
        //   title: "Price",
        //   key: "harga",
        //   scopedSlots: { customRender: "harga" },
        //   width: 150,
        // },
        // {
        //   title: "Potential Tax",
        //   key: "potensial_tax",
        //   scopedSlots: { customRender: "potensial_tax" },
        //   width: 150,
        // },
        {
          title: "No.Verification",
          key: "no_trans",
          scopedSlots: { customRender: "no_trans" },
          width: 150,
        },
        {
          title: "Type tax",
          key: "type_tax",
          scopedSlots: { customRender: "type_tax" },
          width: 150,
        },
        {
          title: "DPP Value",
          key: "dpp_value",
          scopedSlots: { customRender: "dpp_value" },
          width: 150,
        },
        {
          title: "Tax Value",
          key: "tax_value",
          scopedSlots: { customRender: "tax_value" },
          width: 150,
        },
        {
          title: "Action",
          key: "action",
          align: "center",
          scopedSlots: { customRender: "action" },
          fixed: "right",
          width: 85,
        },
      ],
    };

    return {
      doc_validation,
      table,
      notfound: { animationData: notfound, loop: true },
      loading: {
        submit: false,
        manifest: false,
        report: false,
        manifestKomisi: false,
        manifestfiktif: false,
        manifestWtNote: false,
      },
      manifest:{
        header: [],
        workflowStatus: [],
        history: [],
        detail_trans: [],
        aksi: [],
        jenis: '',
        total_credit: 0,
        total_refund: 0,
        grand_total: 0,
      },
      visibleHistory: false,
      pagination: {
        onChange: (page) => { this.pagination.page = page},
        page: 1,
        pageSize: 5,
        size: "small",
      },
      search: "",
      visibleUploadDoc: false,
      uploadDoc: {
        file: null,
        doctransfiles: null,
        id_dtl_trans: null,
        tanggal: null,
        deskripsi: null,
        loading: false,
      },
      visibleTaxDeposite: false,

      dataEdit: [],
      isvat: true,
      spinning_form: false,
      modalData: {
        id_tax_verif_trans: "",
        costcenter: [],
        costcenterOri: [],
        jenis_anggaran: [],
        kode_anggaran: [],
        kode_anggaranOri: [],
        peruntukan: [],
        peruntukanOri: [],
        sub_peruntukan: [],
        sub_peruntukanOri: [],
        treeExpandedKeys: [],
        detil_transaction: [],
        init_detil_transaction: {},
        anggaran: {
          tree: [],
          loadingtree: false,
        },
        listsetoranpajak: [],
        listsetoranpajakOri: [],
        listobjekpajak: [],
        fileList: [],
        dtl_value: "",
        state_modal: 'add'
      },
      addVarification: false,
      deleteVarification: false,
      data_verif_dtl: [],
      paginationverificationdtl: {
        onChange: (page) => {
          this.pagination.page = page;
        },
        page: 1,
        pageSize: 10,
        size: "small",
      },
      dataTax: [],
    }
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
    this.formmodal = this.$form.createForm(this);
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getDateTimeFormat",
      "getIsSpecialMenu",
      "getStandartFormatDate",
      "getType_tax",
    ]),
    searching() {
      let data_ = [];
      if (this.search) {
        data_ = this.manifest.detail_trans.filter(
          (obj) =>
          (obj.expense_date && moment(obj.expense_date).format(this.getDefaultDateFormat).indexOf(this.search.toLowerCase()) >= 0) ||
          (obj.type_ticket && obj.type_ticket.toLowerCase().indexOf(this.search.toLowerCase()) >= 0) ||
          (obj.user_booking && obj.user_booking.toLowerCase().indexOf(this.search.toLowerCase()) >= 0) ||
          (obj.no_booking && obj.no_booking.toLowerCase().indexOf(this.search.toLowerCase()) >= 0) ||
          (obj.credit && this.formatRupiah(obj.credit).toLowerCase().indexOf(this.search.toLowerCase()) >= 0) ||
          (obj.no_sppd && obj.no_sppd.toLowerCase().indexOf(this.search.toLowerCase()) >= 0) ||
          (obj.no_pp && obj.no_pp.toLowerCase().indexOf(this.search.toLowerCase()) >= 0) ||
          (obj.cost_center && obj.cost_center.toLowerCase().indexOf(this.search.toLowerCase()) >= 0) ||
          (obj.iscommision && (obj.iscommision=='1' ? 'yes' : 'no').indexOf(this.search.toLowerCase()) >= 0)
        );
      }else{
        data_ = this.manifest.detail_trans
      }

      return data_;
    },
    columns() {
      const kolom = [
        {
          title: "No",
          key: "no",
          width: 50,
          align: "right",
          scopedSlots: { customRender: "no" },
        },
        {
          title: "Date",
          width: 100,
          key: "tgl",
          align: "center",
          scopedSlots: { customRender: "tgl" },
          sorter: (a, b) =>
            new Date(
              moment(a.expense_date).format(
                this.getStandartFormatDate
              )
            ) -
            new Date(
              moment(b.expense_date).format(
                this.getStandartFormatDate
              )
            ),
        },
        {
          title: "Ticket Type / User Booking / No Booking ",
          scopedSlots: { customRender: "type" },
          width: 300,
          sorter: (a, b) => (a.type_ticket+a.user_booking+a.no_booking).localeCompare(b.type_ticket+b.user_booking+b.no_booking),
        },
        {
          title: "Value",
          key: "val",
          width: 180,
          sorter: (a, b) => a.credit - b.credit,
          scopedSlots: { customRender: "val" },
        },        
        {
          title: "Budget (No SPPD/PP/Cost Center)",
          key: "budget",
          width: 300,
          sorter: (a, b) => (a.no_sppd || a.no_pp || a.cost_center).localeCompare(b.no_sppd || b.no_pp || b.cost_center),
          scopedSlots: { customRender: "budget" },
        },
        {
          title: "Description",
          key: "desc",
          dataIndex: "description",
          width: 300,
        },
        {
          title: "IsCommision",
          key: "iscommision",
          width: 120,
          align: "center",
          sorter: (a, b) => (a.iscommision=='1' ? 'Yes' : 'No').localeCompare(b.iscommision=='1' ? 'Yes' : 'No'),
          scopedSlots: { customRender: "iscommision" },
        },
        {
          title: "Document",
          key: "document",
          scopedSlots: { customRender: "document" },
          width: 150,
          align: "center"
        },
      ];

      if(this.isTaxOfficer){
        kolom.push({
          title: "Tax Deposit",
          key: "doc_tax",
          fixed: "right",
          scopedSlots: { customRender: "doc_tax" },
          width: 100,
        },);
      }

      return kolom;
    },
    isTaxOfficer(){
      let data = _.filter(this.getAuth.nama_bidang,(obj) => obj=="Tax Officer");
      return data.length>0 ? true : false;
    },
    getType_taxFiltered(){
      return this.getType_tax.filter((obj)=> obj.value!='bea_masuk')
    },
  },
  created(){
    this.$store.dispatch("Fetch_TYPE_TAX");
  },
  mounted(){
    Event.$on("confirmMessageReturn", this.submit);
    this.fetchManifest()
  },
  beforeDestroy() {
    Event.$off("confirmMessageReturn", this.submit);
  },
  methods: {
    moment,
    fetchManifest() {
      this.loading.manifest = true;
      axios({
        method: "get",
        url: this.$serviceUrl + "klaim_tiket",
        params: {
          id_laporan: this.id,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.manifest.header = response.data.invoice[0];
          this.manifest.workflowStatus = response.data.status_app;
          this.manifest.history = response.data.notifikasi;
          this.manifest.lastStatus = response.data.invoice[0].status;
          this.manifest.jenis = response.data.jenis;
          this.manifest.detail_trans = response.data.dtl_invoice;
          this.manifest.aksi = response.data.aksi;

          this.manifest.total_credit = response.data.total_credit
          this.manifest.total_refund = response.data.total_refund
          this.manifest.grand_total = response.data.grand_total

          this.loading.manifest = false;
        })
        .catch((err) => {
          if (!err.response) {
            this.displayMessage("choose-again");
            console.log(err);
          } else {
            this.displayMessage("denied-manifest");
            this.$router.push({ name: "beranda" });
          }
        });
    },
    historyToggle(e) {
      e.stopPropagation();
      this.visibleHistory = !this.visibleHistory;
    },
    viewlampiranDoc(url) {
      window.open(this.$serviceUrl + url, "_blank");
    },
    handleUploadDoc(item) {
      this.visibleUploadDoc = true;
      this.uploadDoc.tanggal = item.expense_date;
      this.uploadDoc.deskripsi = item.type_ticket+" / "+item.user_booking+" / "+item.no_booking;
      this.uploadDoc.id_dtl_trans = item.id;
    },
    beforedoctransUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 5) {
        this.displayMessage("large-file-5mb");
      } else {
        let data = new FormData();
        data.append("tipe_trans", "lap_um_pp");
        data.append("id_dtl_trans", this.uploadDoc.id_dtl_trans);
        data.append("file_upload", file);

        this.uploadDoc.loading = true;
        this.asyncAxiosPost("main/upload_lampiranxxx", "formdata", this.getAuth, data)
          .then((response) => {
            if (response.status && response.status == true) {
              this.displayMessageValue("success-other", response.message);
            } else {
              let responses = Object.assign({}, response);
              this.displayMessageValue("error-other", responses);
            }
            this.uploadDoc.loading = false;
            this.getDetailPemakaianWeb();
            this.visibleUploadDoc = false;
          })
          .catch((err) => {
            console.log(err);
            this.uploadDoc.loading = false;
            if (err.response && err.response.data) {
              this.$notification.error({
                message: "Error Message",
                description: err.response.data.message,
              });
            } else {
              let responses = Object.assign({}, err.response);
              this.displayMessageValue("error", responses);
            }
          });
        this.uploadDoc.doctransfiles = [file];
        return false;
      }
    },
    handledoctransRemove() {
      this.uploadDoc.doctransfiles = [];
    },
    handleShowTaxModal(params){
      this.fetchDetailTax(params)
      this.dataTax.tax_type = params.tax_type;
      this.visibleTaxDeposite = true
      this.edit_state = params
    },
    async fetchDetailTax(val){
      this.spinning_form = true
      try {
        const response = await axios({
          method: "get",
          url: this.$serviceUrl + "tax_verification/tax_detil",
          params: {
            jenis_transaksi: "klaim_traveloka",
            id_header: this.manifest.header.id_laporan,
            id_dtl: val.id,
          },
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "X-API-KEY": this.getAuth.apikey,
          },
        })

        this.modalData.detil_transaction = response.data.detil_transaction
        this.modalData.init_detil_transaction = response.data.detil_transaction[0]
        this.modalData.costcenter = response.data.cost_center
        this.modalData.peruntukan = response.data.peruntukan
        this.modalData.peruntukanOri = response.data.peruntukan
        this.modalData.listsetoranpajak = response.data.setoran
        this.modalData.listsetoranpajakOri = response.data.setoran
        this.modalData.listobjekpajak = response.data.objek
        this.data_verif_dtl = response.data.list_tax_dtl
        this.jns_transaksi = response.data.jenis_transaksi

        if(this.modalData.init_detil_transaction.peruntukan_id && 
          this.modalData.init_detil_transaction.anggaran_dtl_id && this.modalData.init_detil_transaction.anggaran_dtl_val_id){
          this.modalData.init_detil_transaction['kode_anggaran'] = 
            this.modalData.init_detil_transaction.peruntukan_id+';'+this.modalData.init_detil_transaction.anggaran_dtl_id+';'+
            this.modalData.init_detil_transaction.anggaran_dtl_val_id;
        }

        if (response.data.list_tax_dtl) {
          this.verificationdtl_source = response.data.list_tax_dtl;
          for (let x = 0; x < this.verificationdtl_source.length; x++) {
            if (this.verificationdtl_source[x].id == undefined)
              this.verificationdtl_source[x].id = this.verificationdtl_source[x].id_dtl;
          }
          this.verificationdtl_sourceOri = this.verificationdtl_source
        }

        if(this.modalData.init_detil_transaction.anggaran_id && 
          this.modalData.init_detil_transaction.peruntukan_id){
          const res = await this.asyncAxiosGet("tax_verification/tree_anggaran", this.getAuth, {
          anggaran_id: this.modalData.init_detil_transaction.anggaran_id,
          peruntukan_id: this.modalData.init_detil_transaction.peruntukan_id,
        })

        this.modalData.anggaran.tree = res.tree;
        }
        this.spinning_form = false
        
      } catch (error) {
        console.log(error);
        this.spinning_form = false
      }
    },
    handleModalClose(){
      this.fetchManifest()
      this.modalData.detil_transaction = []
      this.visibleTaxDeposite = false
      this.clearForm()
      this.modalData.anggaran.tree = null;
      this.modalData.reftax_type = null
      this.modalData.state_modal = 'add'
    },
    filterOptiondtl(val){
      // console.log(val);
      
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    handle_DetilTransaction(val){
      // console.log(val);
    },
    async handleChangeVat(val){
      if (val.target.value == "1") {
        this.isvat = true;
        this.$nextTick(function () {
          this.formmodal.setFieldsValue({
            kode_anggaran: null,
          });
        });
      } else if (val.target.value == "0") {
        this.isvat = false;
        let anggaran_id = this.modalData.init_detil_transaction.anggaran_id;
        let id_dtl = this.modalData.init_detil_transaction.id_dtl;
        if (!anggaran_id) {
          return
        }

        let dataFiltered = _.filter(this.modalData.peruntukanOri, (el) => el.anggaran_id == anggaran_id);
        this.modalData.peruntukan = dataFiltered

        try {
          await this.handle_DetilTransaction2(id_dtl, val.target.value);
        } catch(err) {
          console.log(err);
        }
      }
    },
    handleCost(e){
      this.$nextTick(function () {
        this.formmodal.setFieldsValue({
          peruntukan: null,
          sub_peruntukan: null,
          kode_anggaran: null,
        });
      });
      this.modalData.subPeruntukan = [];
      const peruntukan = this.modalData.peruntukanOri.filter(
        (obj) => obj.anggaran_id.toLowerCase().indexOf(e.toLowerCase()) >= 0
      );
      this.modalData.peruntukan = peruntukan;
    },
    async handle_Peruntukan(e){
      try {
        let anggId = this.formmodal.getFieldValue("cost_center")
        if (anggId) {
          this.modalData.anggaran.loadingtree = true
          this.$nextTick(function () {
            this.formmodal.setFieldsValue({
              kode_anggaran: null,
            });
          });
          const res = await this.asyncAxiosGet("tax_verification/tree_anggaran", this.getAuth, {
            anggaran_id: anggId,
            peruntukan_id: e,
          })

          this.modalData.anggaran.tree = res.tree;
          this.modalData.treeExpandedKeys = this.getParent(
            this.modalData.anggaran.tree
          );
          this.modalData.anggaran.loadingtree = false;
 
        } else {
          this.displayMessageValue("error-other", "Cost Center Must be selected first!");
        }
      } catch (error) {
        this.modalData.anggaran.loadingtree = false;
        let responses = Object.assign({}, error.response.data);
        this.displayMessageValue("error-other", responses.message);
      }
    },
    filterTreeNode(input, option) {
      return (
        option.data.props.texttitle == undefined ||
        (option.data.props.texttitle ? option.data.props.texttitle : "")
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0 ||
        (option.data.props.kode_anggaran ? option.data.props.kode_anggaran : "")
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    handlechoiceCost(val){
      // console.log(val);
      
    },
    handleChangeTaxType(e) {
      this.modalData.reftax_type = e;
      this.$nextTick(function () {
        this.formmodal.setFieldsValue({
          kode_setoran_pajak: null,
        });
      });
      this.filtertaxDeposit(e);
    },
    filtertaxDeposit(val) {
      this.modalData.listsetoranpajak = _.filter(this.modalData.listsetoranpajakOri, (item) => item.id_type_tax == val);
    },
    checkPrice(rule, value, callback) {
      if (value > 0) {
        callback();
        return;
      }
      callback("Value must greater than zero!");
    },
    handleRemoveAttachment() {
      this.modalData.fileList = [];
    },
    beforeUploadAttachment(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 5) {
        this.displayMessage("large-file-5mb");
      } else {
        this.modalData.fileList = [];
        this.modalData.fileList.push(file);
        return false;
      }
    },
    handleAddVarification(){
      this.addVarification = true;
      this.formmodal.validateFields( async (err, values) => {
        if (err) {
          this.addVarification = false;
          this.displayMessage("form-warning");
          return;
        }

        let payload = new FormData()
        try {
          payload.append('tax_type', values.tax_type)
          payload.append('tax_deposit', values.kode_setoran_pajak)
          payload.append('dpp_value', values.dpp_value)
          payload.append('tax_value', values.tax_value)
          payload.append('jenis_transaksi', this.jns_transaksi)
          payload.append('id_header', this.modalData.init_detil_transaction.id_header)
          payload.append('id_dtl', this.modalData.init_detil_transaction.id_dtl)
          payload.append('description', this.modalData.init_detil_transaction.deskripsi)
          
          if(values.tax_type !== 'ppn' && values.tax_type !== 'pph_21') {
            payload.append('tax_object', values.objek_pajak ? values.objek_pajak : null)
          }
          if(values.is_vat !== '1'){
            let array_code = values.kode_anggaran.split(';');            
            payload.append('kode_anggaran', array_code[2])
          }
          if (this.modalData.fileList.length > 0)
          payload.append("file_document_tax", this.modalData.fileList[0]);

          const res = await axios({
            method: "post",
            url: this.$serviceUrl + "Tax_verification/tax_detil",
            processData: false,
            data: payload,
            auth: {
              username: this.getAuth.username,
              password: this.getAuth.password,
            },
            headers: {
              "Content-Type": "application/json",
              "X-API-KEY": this.getAuth.apikey,
            },
          })

          if(res){
            this.displayMessage("success-save");
            this.data_verif_dtl = res.data.list_tax_dtl

            this.clearForm()
          }
          this.addVarification = false;
        } catch (error) {
          console.log(error);
          this.addVarification = false;
        }
      });
    },
    submitConfirm() {
      this.form.validateFields((err, values) => {
        if (err) {
          return;
        }
        this.confirmMessage("confirm-save");
      })
    },
    submit() {
      this.form.validateFields((err, values) => {
        if (err) {
          return;
        }
        this.postData = new FormData();
        this.postData.append("tlc", this.getAuth.username);
        this.postData.append("id_laporan", this.id);
        this.postData.append(
          "remark",
          values.catatan ? values.catatan : ""
        );
        this.postData.append("status", values.status);

        this.loading.submit = true
        axios({
          method: "post",
          url: this.$serviceUrl + "klaim_tiket/approval",

          data: this.postData,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "Content-Type": "multipart/form-data",
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            this.displayMessage("success-edit");
            this.$router.go(0);
            /* this.$router.push({ name: "umpd" }); */
          })
          .catch((err) => {
            console.log("error : " + err);
          });
      });
    },
    handleEdit() {
      this.$router.push({
        name: "travelokaklaimRevise",
        params: { id: this.id},
      });
    },
    handlePrintReport(val) {
      if(val=='komisi'){
        this.loading.manifestKomisi = true;
      }else if(val=='fiktif'){
        this.loading.manifestfiktif = true;
      }else if(val=='tanpa_nota'){
        this.loading.manifestWtNote = true;
      }else{
        this.loading.report = true;
      }
      axios({
        method: "get",
        url: this.$serviceUrl + "klaim_tiket/cetak_klaim_traveloka",
        responseType: "blob",
        params: {
          tlc: this.getAuth.username,
          id: this.id,
          komisi: (val=='komisi' ? 'y' : 'n'),
          fiktif: (val=='fiktif' ? 'y' : 'n'),
          tanpa_nota: (val=='tanpa_nota' ? 'y' : 'n')
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          let blob = new Blob([response.data], { type: "application/pdf" }),
            url = window.URL.createObjectURL(blob);
          window.open(url, "_blank");
          
          if(val=='komisi'){
            this.loading.manifestKomisi = false;
          }else if(val=='fiktif'){
            this.loading.manifestfiktif = false;
          }else if(val=='tanpa_nota'){
            this.loading.manifestWtNote = false;
          }else{
            this.loading.report = false;
          }
        })
        .catch((err) => {
          if (err.response.status === 404) {
            this.displayMessage("404");
          }
          
          if(val=='komisi'){
            this.loading.manifestKomisi = false;
          }else if(val=='fiktif'){
            this.loading.manifestfiktif = false;
          }else if(val=='tanpa_nota'){
            this.loading.manifestWtNote = false;
          }else{
            this.loading.report = false;
          }

          this.$router.go(-1);
        });
    },
    gettitletax(val) {
      let res = this.getType_tax.filter((el) => el.value == val);
      return res.length > 0 ? res[0].text : "-";
    },
    clearForm(){
      this.formmodal.setFieldsValue({
        tax_type: null,
        kode_setoran_pajak: null,
        objek_pajak: null,
        dpp_value: null,
        tax_value: null,
        is_vat: '1'
      });
      this.modalData.fileList = []
      this.isvat = true
      this.modalData.reftax_type = ""
      // this.modalData.anggaran.tree = null;
    },
    async editdtl(val){
      this.edit_state = val
      this.spinning_form = true

      this.modalData.state_modal = 'edit'
      this.modalData.reftax_type = val.tax_type
      this.formmodal.setFieldsValue({
        tax_type: val.tax_type,
        kode_setoran_pajak: val.tax_deposit_id,
        dpp_value: val.dpp_value,
        tax_value: val.tax_value,
        is_vat: val.id_anggaran !== null ? '0' : '1',
        kode_anggaran: val.id_anggaran
      });

      if(val.tax_object_id !== null){
        this.formmodal.setFieldsValue({
          objek_pajak: val.tax_object_id
        });
      }

      if(val.tax_document_name){
        this.handlingBinaryFiles(val)
      }
      
      if(val.id_anggaran !== null){
        this.isvat = false;
        let anggaran_id = this.modalData.init_detil_transaction.anggaran_id;
        let id_dtl = this.modalData.init_detil_transaction.id_dtl;
        if (!anggaran_id) {
          return
        }
      
        try {
          this.modalData.peruntukan = _.filter(this.modalData.peruntukanOri, (el) => el.anggaran_id == anggaran_id);
          await this.handle_DetilTransaction2(id_dtl, '0');
        } catch(err) {
          console.log(err);
          this.spinning_form = false;
        } 
        finally {
          this.spinning_form = false;
        }
      }else {
        this.isvat = true;
        setTimeout(() => {
          this.spinning_form = false
        }, 500)
      }
    },
    deletedtl(id) {
      const that = this;
      that.deleteVarification = true;
      that.modalProcessKey = id;
      this.$confirm({
        title: "Are you sure to delete this data?",
        content: "",
        okText: "Yes",
        cancelText: "No",
        onOk() {
          that.deleteVarification = true;
          that.modalProcessKey = id;

          that.asyncAxiosDelete(
            "Tax_verification",
            "application/json",
            that.getAuth,
            { id: id }
          ).then(() => {
            that.deleteVarification = false;
            that.modalProcessKey = "";
            let newData = that.data_verif_dtl.filter((d) => d.id !== id);
            that.data_verif_dtl = newData
            that.displayMessage("success-del");
          }).catch((err) => {
            console.log(err);
            that.deleteVarification = false;
            that.modalProcessKey = "";
          });
        },
        onCancel() {
          that.deleteVarification = false;
          that.modalProcessKey = "";
        },
      })
    },
    handleUpdateDetail(){
      this.formmodal.validateFields( async (err, values) => {
        if(err){
          this.displayMessage("form-warning");
          return;
        }

        let payload = new FormData()
        try {
          payload.append('id', this.edit_state.id)
          payload.append('tax_type', values.tax_type)
          payload.append('tax_deposit', values.kode_setoran_pajak)
          payload.append('dpp_value', values.dpp_value)
          payload.append('tax_value', values.tax_value)
          payload.append('jenis_transaksi', this.jns_transaksi)
          payload.append('id_header', this.modalData.init_detil_transaction.id_header)
          payload.append('id_dtl', this.modalData.init_detil_transaction.id_dtl)
          payload.append('description', this.modalData.init_detil_transaction.deskripsi)
          
          if(values.tax_type !== 'ppn' && values.tax_type !== 'pph_21') {
            payload.append('tax_object', values.objek_pajak)
          }
          if(values.is_vat !== '1'){
            let array_code = values.kode_anggaran.split(';');            
            payload.append('kode_anggaran', array_code[2])
          }
          if (this.modalData.fileList.length > 0)
          payload.append("file_document_tax", this.modalData.fileList[0]);

          const res = await axios({
            method: "post",
            url: this.$serviceUrl + "Tax_verification/tax_detil_edit",
            processData: false,
            data: payload,
            auth: {
              username: this.getAuth.username,
              password: this.getAuth.password,
            },
            headers: {
              "Content-Type": "application/json",
              "X-API-KEY": this.getAuth.apikey,
            },
          })

          if(res){
            this.displayMessage("success-edit");
            this.data_verif_dtl = res.data.list_tax_dtl
            this.clearForm()
          }
          this.addVarification = false;
          this.modalData.state_modal = 'add'
        } catch (error) {
          console.log(error);
          this.addVarification = false;
        }
        
      })
    },
    handleCancelVarification(){
      this.clearForm()
      this.modalData.state_modal = 'add'
    },
    async handle_DetilTransaction2(e, isvat) {
      if (isvat !== "0") return 
      try {
        this.modalData.anggaran.loadingtree = true;
        let params = _.filter(this.modalData.detil_transaction, (item) => item.id_dtl == e);

        this.$nextTick(function () {
          this.formmodal.setFieldsValue({
            cost_center: params[0].anggaran_id,
            peruntukan: params[0].peruntukan_id,
          });
        });

        const res = await this.asyncAxiosGet("tax_verification/tree_anggaran", this.getAuth, {
          anggaran_id: params[0].anggaran_id,
          peruntukan_id: params[0].peruntukan_id,
        })

        this.modalData.anggaran.tree = res.tree;
        this.modalData.treeExpandedKeys = this.getParent(
          this.modalData.anggaran.tree
        );
        this.modalData.anggaran.loadingtree = false;

      } catch (error) {
        console.log(error);
        
        this.modalData.anggaran.loadingtree = false;
        let responses = Object.assign({}, error.response.data);
        this.displayMessageValue("error-other", responses.message);
      }
    },
    getParent(root) {
      let data = [];
      root.forEach((item) => {
        if (item.key) {
          data.push(item.key);
        }

        if (item.children.length > 0) {
          item.children.forEach((d) => {
            data.push(d.key);
          });
        }
      });
      return data;
    },
    handlingBinaryFiles(item){
      if(item.tax_document_path){
        this.asyncAxiosGet("main/base_64", this.getAuth, {
          path: item.lampiran_path,
        })
        .then((response) => {
          let typefile = this.fileTypeFromUrl(item.tax_document_name);
          let file = this.dataURLtoFile(
            typefile + response.file_document_tax,
            item.tax_document_name
          );
          file.uid = "vc-upload-1-1";
          file.status = "done";
          file.url = this.$serviceUrl + item.tax_document_path;
          this.modalData.fileList = [];
          this.modalData.fileList.push(file);
        })
          .catch((err) => {
          console.log(err);
          let responses = Object.assign({}, err.response.data);
          this.displayMessageValue("error-other", responses.message);
        });
      }
    }
  }
}
</script>
<style lang="less">
.s_trans{
  .ant-select-selection-selected-value{
    width: 100%;
  }
}
</style>